import React, { useState } from 'react';

const AdmissionPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: 1, src: "image1.png", alt: "Student 1" },
    { id: 2, src: "image2.png", alt: "Student 2" },
    { id: 3, src: "image4.png", alt: "Student 4" },
    { id: 4, src: "image6.png", alt: "Student 6" },
    { id: 5, src: "image6.png", alt: "Hero student" }
  ];

  const openImage = (imageSrc) => {
    setSelectedImage(imageSrc);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <div className="bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <div className="relative bg-gradient-to-r from-blue-900 to-blue-800 text-white overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-orange-500 rounded-full opacity-20 blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-400 rounded-full opacity-20 blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-block bg-orange-500 text-white px-3 py-0.5 rounded-full text-xs font-semibold mb-3 shadow-lg shadow-orange-500/30">
                ADMISSION NOW OPEN
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3">
                BBA & BCA <br />
                <span className="text-orange-400">COURSE</span>
              </h1>
              <p className="text-blue-100 text-base mb-4">
                Start your journey with RDS Mahavidyalay
              </p>
              <div className="flex flex-wrap gap-3">
                <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-6 rounded-full transition-all duration-300 shadow-lg text-sm">
                  REGISTER NOW
                </button>
                <button className="bg-white/10 hover:bg-white/20 text-white font-bold py-2 px-6 rounded-full transition-all duration-300 backdrop-blur-sm border border-white/30 text-sm">
                  Learn More
                </button>
              </div>
            </div>
            <div className="relative">
              <img
                src="image6.png"
                alt="Students celebrating"
                className="rounded-xl shadow-2xl border-4 border-white/20 h-64 w-full object-cover cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImage("image6.png")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-4 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 items-start">
            <div className="grid grid-cols-2 gap-3">
              <img
                src="https://images.shiksha.com/mediadata/images/articles/1564987760phpQwC6bG.jpeg"
                className="rounded-lg shadow h-40 w-full object-cover cursor-pointer hover:opacity-90 transition-opacity hover:scale-105 transform duration-300"
                onClick={() => openImage("https://images.shiksha.com/mediadata/images/articles/1564987760phpQwC6bG.jpeg")}
              />
              <img
                src="https://sgtuniversity.ac.in/assets/images/faculty/commerce-%26-management/programme/cm-img-08.jpg"
                className="rounded-lg shadow h-40 w-full object-cover mt-4 cursor-pointer hover:opacity-90 transition-opacity hover:scale-105 transform duration-300"
                onClick={() => openImage("https://sgtuniversity.ac.in/assets/images/faculty/commerce-%26-management/programme/cm-img-08.jpg")}
              />
              <img
                src="https://refurbo.in/_next/image?q=75&url=https%3A%2F%2Frefurbo.in%2Fblogs%2Fcontent%2Fimages%2F2025%2F12%2Fschool.jpg&w=1920"
                className="rounded-lg shadow h-40 w-full object-cover cursor-pointer hover:opacity-90 transition-opacity hover:scale-105 transform duration-300"
                onClick={() => openImage("https://refurbo.in/_next/image?q=75&url=https%3A%2F%2Frefurbo.in%2Fblogs%2Fcontent%2Fimages%2F2025%2F12%2Fschool.jpg&w=1920")}
              />
              <img
                src="https://m.economictimes.com/thumb/height-450%2Cwidth-600%2Cimgsize-177412%2Cmsid-113803595/boardroom-meeting-istock.jpg"
                className="rounded-lg shadow h-40 w-full object-cover mt-4 cursor-pointer hover:opacity-90 transition-opacity hover:scale-105 transform duration-300"
                onClick={() => openImage("https://m.economictimes.com/thumb/height-450%2Cwidth-600%2Cimgsize-177412%2Cmsid-113803595/boardroom-meeting-istock.jpg")}
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-blue-800 mb-3">ABOUT US</h2>
              <h3 className="text-xl text-orange-500 font-semibold mb-4">BCA & BBA Programs</h3>
              
              <div className="space-y-5 mb-6">
                <div className="bg-orange-50 p-5 rounded-lg border-l-4 border-orange-500">
                  <h4 className="font-bold text-blue-800 text-lg mb-2">BCA</h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Designed for students aspiring to build careers in software development, IT services, and emerging technologies. The program blends theoretical knowledge with practical skills to prepare graduates for the digital economy.
                  </p>
                </div>
                
                <div className="bg-orange-50 p-5 rounded-lg border-l-4 border-orange-500">
                  <h4 className="font-bold text-blue-800 text-lg mb-2">BBA</h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Focused on management, leadership, and entrepreneurship, this course equips students with the analytical and communication skills needed to excel in business and administration.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={closeImage}
        >
          <div className="relative max-w-5xl max-h-[90vh] w-full">
            <button 
              className="absolute -top-12 right-0 text-white hover:text-orange-500 text-2xl font-bold"
              onClick={closeImage}
            >
              ✕
            </button>
            <img
              src={selectedImage}
              alt="Enlarged view"
              className="w-full h-full object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdmissionPage;